import StoreAdvancedView from './StoreAdvancedView'

export default StoreAdvancedView
